export default __webpack_public_path__ + "static/media/fb-messenger.9b75c832.jpg";